import React from 'react';
import SarasMenu from '../../../../library/repeater/menu/SarasMenu'
import SarasFormMenuRow from '../../../../library/repeater/menu/SarasFormMenuRow'
import ActionButton from '../../../../library/input/buttons/button/SarasButton2';
import SarasConfirmPrompt from "../../../../library/notifications/SarasConfirmPrompt";
import SarasTrans from "../../../../library/notifications/SarasTrans"
import * as fn from "../../../../helper/uiFunctions";

const DocStatusAction = (props) => {
    const { formObject, viewData, rowID, reloadSearch } = props;

    const [confirmPromptData,setConfirmPromptData] = React.useState({})
    const statusStyle = JSON.parse(formObject.getValueFromKey(viewData, "dataList.style", "{}"));
    const isHideList = JSON.parse(formObject.getValueFromKey(viewData, "dataList.hideList", "0"));
    
    const onActionSuccess = () => {
        // console.log("DocStatusAction onSuccess", reloadSearch);
        if(reloadSearch)reloadSearch();
    }

    const renderFormMenu = () => {
        //const MenuIcon = Icon[icon];
        return (
            <ActionButton className='uiContextMenu' />
        )
    }

    const onMenuItemCLick = (e, value) => {
        // console.log("form button clicked");
        if(value)
        {
            let selectedItem = getSelectedRow(value);
            let promptMsg = `Change status to ${selectedItem.valF}?`
            setConfirmPromptData({message:promptMsg, callback:() => {executeStatusChangeAction(e, value)}});
        }
        else{
            executeStatusChangeAction(e, value)
        }
    }

    const getSelectedRow = (value) => {
        if (value) {
            // let selectedItem = menuList[value];
            // if (!selectedItem)
            let selectedItem = menuList[Object.keys(menuList)[value]]
            return selectedItem
        }
    }

    const executeStatusChangeAction = (e, value) => {
        let SelectedItem = getSelectedRow(value);
        let datalist = SelectedItem.dataList;
        let actionParam = formObject.convertStrToKeyValue(datalist.actionParam);

        let customAction = { actionId: datalist.actId, isCompHeader: 0,  actionParam: { ...actionParam,"viewCaller":"InSearch" }, onSuccess: onActionSuccess}
        customAction["actionName"] = formObject.getValueFromKey(viewData, "dataList.actionName", "");
        customAction.actionParam["dId"] = formObject.getValueFromKey(viewData, "dataList.dId", "0");
        customAction.actionParam["compoId"] = formObject.getValueFromKey(viewData, "dataList.compoId", "0");
        customAction.actionParam["lineId"] = formObject.getValueFromKey(viewData, "dataList.rowId", "0");
        
        formObject.onFormAction(customAction, rowID, "");
    }

    const renderMenu = () => {
        let list = Object.values(menuList);
        if (fn.compareNumber(isHideList, 0) && list.length > 0) {
            return (
                <SarasMenu menuTrigger={renderFormMenu()}
                    dataList={list}
                    menuItem={SarasFormMenuRow} onSelection={onMenuItemCLick}
                />
            )
        }
        else
            return (null)
    }

    if (!viewData)
        return (null)

    const menuList = viewData.childRows[0].rowValues;
    return (
        <div className="saras-cell">
            <SarasConfirmPrompt promptData={confirmPromptData} />
            <span className="uiDocumentStatus" style={statusStyle}>
                <SarasTrans value={viewData.val} />
            </span>
            {renderMenu()}
        </div>
    )
}

export default DocStatusAction